import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { Edges, VIEWPORTS } from '../../../styles/Grid/GridSizes';
import MediaQueries from '../../../styles/Grid/MediaQueries';

export const contentCss = contentBackground => ({
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  padding: 0,
  borderRadius: 0,
  border: 0,
  background: contentBackground,
});

export const overlayCss = {
  zIndex: 10,
  opacity: '1',
};

export const closeButtonCss = css({
  alignItems: 'center',
  background: 'none',
  border: 0,
  cursor: 'pointer',
  display: 'flex',
  height: 24,
  padding: 0,
  position: 'absolute',
  right: 24,
  top: 24,
  width: 'auto',
  zIndex: 2,
  [MediaQueries.mdAndUp]: {
    right: Edges[VIEWPORTS.md],
    top: 64,
  },
  [MediaQueries.lgAndUp]: {
    right: Edges[VIEWPORTS.lg],
    top: 96,
  },
  [MediaQueries.xl]: {
    right: Edges[VIEWPORTS.xl],
  },
});

export const iconCss = css({
  fontSize: 18,
  marginRight: 12,
});

const linesPartialCss = {
  content: '""',
  display: 'block',
  width: 62,
  height: 2,
  backgroundColor: colorsPalette.grey,
  position: 'absolute',
};

export const bigIconCss = css({
  transform: 'translateX(-13px)',
  position: 'relative',

  [MediaQueries.mdAndUp]: {
    display: 'block',
    ':before': {
      ...linesPartialCss,
      transform: 'rotate(45deg)',
    },
    ':after': {
      ...linesPartialCss,
      transform: 'rotate(-45deg)',
    },
  },
});
